export default "__VITE_ASSET__275b2442__"